var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdfPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 168,
  viewBox: "0 0 100 168",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7C4CE",
  fillRule: "nonzero",
  d: "M96 88a4 4 0 0 1 4 4v72a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V92a4 4 0 0 1 4-4zm-84 4H4v72h92V92H46v64H12zm30 0H16v60h26zm58-16a4 4 0 0 1-3.8 3.995L96 80H4a4 4 0 0 1-3.995-3.8L0 76V4A4 4 0 0 1 3.8.005L4 0h84v.007l12 11.991zM84 4H4v72h8V48h34v28h50V16H84zM42 52H16v24h26zm4-28v16H12V24zm25 12v4H54v-4zm-29-8H16v8h26zm46-4v4H54v-4zM76 12v4H12v-4zm18.344 0L88 5.662V12z"
})));
export default SvgPdfPrint;